"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconWebWorldFilled = function IconWebWorldFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.52,21a17.19,17.19,0,0,0-1.05-3A17,17,0,0,0,27.65,8.21,12.94,12.94,0,0,0,25.88,8h0c-.29,0-.57,0-.87,0s-.59,0-.88,0a12.94,12.94,0,0,0-1.77.18A17,17,0,0,0,9.53,18a17.19,17.19,0,0,0-1,3A17.47,17.47,0,0,0,8,25,17.15,17.15,0,0,0,8.46,29a16.34,16.34,0,0,0,1,3,17,17,0,0,0,12.86,9.84,14.74,14.74,0,0,0,1.77.19L25,42l.88,0h0a14.57,14.57,0,0,0,1.76-.19A17,17,0,0,0,40.51,32a16.34,16.34,0,0,0,1-3A17.15,17.15,0,0,0,42,25,17.47,17.47,0,0,0,41.52,21Zm-4.44-3H31.66a2.48,2.48,0,0,0-.13-.35l-2.47-6A14,14,0,0,1,37.08,18ZM29.5,29h-9a16.17,16.17,0,0,1,0-8h9A16.17,16.17,0,0,1,29.5,29ZM25.56,39a7.85,7.85,0,0,1-1.12,0l-2.89-7h6.9ZM24.43,11a8.13,8.13,0,0,1,1.14,0L28.42,18H21.58Zm-3.49.6-2.47,6a2.48,2.48,0,0,0-.13.35H12.92A14,14,0,0,1,20.94,11.62ZM11.38,28.26A14.31,14.31,0,0,1,11,25a14.16,14.16,0,0,1,.39-3.32c.06-.25.14-.49.22-.73h5.82a18.93,18.93,0,0,0,0,8H11.58C11.51,28.72,11.44,28.49,11.38,28.26ZM12.86,32h5.46c0,.12.09.24.14.36L21,38.4A14.07,14.07,0,0,1,12.86,32Zm16.19,6.44,2.49-6.08c.05-.12.1-.24.14-.36h5.46A14,14,0,0,1,29.05,38.39Zm9.57-10.14c0,.24-.13.47-.2.7H32.57a18.93,18.93,0,0,0,0-8h5.82c.07.23.15.46.21.7a14.16,14.16,0,0,1,0,6.6Z",
    fill: color
  }));
};

IconWebWorldFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconWebWorldFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconWebWorldFilled;
exports.default = _default;